
<agpr-take-over-panel
    [header]="(header | localize) + contactName"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="closeDialog()"
    [width]="80"
>
    <div
        class="agpr-emailComposerOvertake"
        [agprLoading]="emailConversationService.loading$ | async"
    >
        <aside
            class="agpr-emailComposerOvertake-sidebar-left"
            [attr.aria-label]="'Common.layout.lhp' | localize"
        >
            <agpr-scroll-panel>
                <div class="agpr-emailComposerOvertake-sidebar-left-scrollPanelContainer">
                    @if (mode === emailComposerModes.CONVERSATION) {
                        @if (isReply) {
                            <div class="agpr-emailComposerOvertake-sidebar-left-reply">
                                <div class="agpr-emailComposerOvertake-fieldContainer">
                                    <span class="agpr-emailComposerOvertake-field-bold">{{ 'Discover.emailComposer.from' | localize}}</span>
                                    <span>
                                        {{newEmailMessage.fromName + ' \<' + newEmailMessage.fromEmail + '\>' }}
                                    </span>
                                </div>
                                <div class="agpr-emailComposerOvertake-fieldContainer">
                                    <span class="agpr-emailComposerOvertake-field-bold">{{ 'Discover.emailComposer.to' | localize}}</span>
                                    <span>
                                        {{ contactName + ' \<' + contactEmail + '\>' }}
                                    </span>
                                </div>
                                <agpr-rich-text-editor-ck
                                    [richTextEditorConfig]="ckEditorConfig"
                                    [(ngModel)]="newEmailMessage.bodyHtml"
                                ></agpr-rich-text-editor-ck>
                                <div class="agpr-emailComposerOvertake-sidebar-left-sendActions">
                                    <agpr-button
                                        [style]="buttonTypes.tertiary"
                                        label="Discover.emailComposer.actions.clear"
                                        (click)="clear()"
                                    ></agpr-button>
                                    <agpr-button
                                        [style]="buttonTypes.tertiary"
                                        label="Discover.emailComposer.actions.send"
                                        (click)="send()"
                                    ></agpr-button>
                                </div>
                            </div>
                        } @else {
                            <div class="agpr-emailComposerOvertake-sidebar-left-viewActions">
                                <agpr-button
                                    [style]="buttonTypes.textToggle"
                                    [label]="expandAll ? 'Discover.emailComposer.actions.expandAll' : 'Discover.emailComposer.actions.collapseAll'"
                                    (click)="toggleExpand()"
                                ></agpr-button>
                                <div class="agpr-emailComposerOvertake-spacer">

                                </div>
                                <agpr-button
                                    [style]="buttonTypes.tertiary"
                                    label="Discover.emailComposer.actions.refresh"
                                    (click)="refresh()"
                                ></agpr-button>
                                @if ((dataConnectionService.hasEmailAccountProvision$ | async) && (dataConnectionService.hasEmailAccountConnectors$ | async)) {
                                    <agpr-button
                                        [style]="buttonTypes.tertiary"
                                        label="Discover.emailComposer.actions.reply"
                                        (click)="reply()"
                                    ></agpr-button>
                                }
                            </div>
                        }
                        @if (showRecentMessageFeedback) {
                            <agpr-message
                                class="agpr-emailComposerOvertake-messages-pending"
                                [severity]="messageSeverityEnum.info"
                            >
                                {{ 'Discover.emailComposer.pending' | localize }}
                            </agpr-message>
                        }
                        @for( message of messages; track message) {
                            <div class="agpr-emailComposerOvertake-message">
                                <div class="agpr-emailComposerOvertake-message-container">
                                    <div class="agpr-emailComposerOvertake-message-label">{{ 'Discover.emailComposer.from' | localize}}</div>
                                    <div class="agpr-emailComposerOvertake-message-value">
                                        {{message.fromName + ' \<' + message.fromEmail + '\>' }}
                                    </div>
                                </div>

                                <div class="agpr-emailComposerOvertake-message-container">
                                    <div class="agpr-emailComposerOvertake-message-label">{{ 'Discover.emailComposer.to' | localize}}</div>
                                    <div class="agpr-emailComposerOvertake-message-value">
                                        {{message.toName + ' \<' + message.toEmail + '\>' }}
                                    </div>
                                </div>

                                <div class="agpr-emailComposerOvertake-message-container">
                                    <div class="agpr-emailComposerOvertake-message-label">{{ 'Discover.emailComposer.date' | localize}}</div>
                                    <div class="agpr-emailComposerOvertake-message-value">
                                        {{ message.date }}
                                    </div>
                                </div>

                                <div class="agpr-emailComposerOvertake-message-container">
                                    <div class="agpr-emailComposerOvertake-message-label">{{ 'Discover.emailComposer.subject' | localize}}</div>
                                    <div class="agpr-emailComposerOvertake-message-subject">
                                        {{ message.subject }}
                                    </div>
                                </div>
                                <div
                                    *ngIf="message.expanded"
                                    class="agpr-emailComposerOvertake-message-body"
                                    [innerHTML]="message.body"
                                >
                                </div>

                                <div class="agpr-emailComposerOvertake-message-expandButton">
                                    <agpr-button
                                        [style]="buttonTypes.icon"
                                        [icon]="message.expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                        [expanded]="message.expanded"
                                        (click)="message.expanded = !message.expanded"
                                    ></agpr-button>
                                </div>
                            </div>
                        }
                    }
                    @if (mode === emailComposerModes.COMPOSE) {
                        <div
                            class="agpr-emailComposerOvertake-field"
                        >
                            <agpr-text-input #subjectLineInput
                                placeholder="Discover.targeting.distribution.headerEditor.subjectLine.placeholder"
                                [(ngModel)]="newEmailMessage.subjectLine"
                                label="Discover.targeting.distribution.headerEditor.subjectLine"
                                tooltip="Discover.targeting.distribution.headerEditor.subjectLine.tooltip"
                                [required]="true"
                                [id]="'emailComposerOvertake_subjectLineInput'"
                                [maxLength]="255"
                                [tooltipLarge]="true"
                            ></agpr-text-input>
                        </div>

                        <div class="agpr-emailComposerOvertake-field">
                            <agpr-text-input #previewTextInput
                                placeholder="Discover.targeting.distribution.headerEditor.previewText.placeholder"
                                label="Discover.targeting.distribution.headerEditor.previewText"
                                tooltip="Discover.targeting.distribution.headerEditor.previewText.tooltip"
                                [(ngModel)]="newEmailMessage.previewText"
                                [id]="'emailComposerOvertake_previewTextInput'"
                                [maxLength]="90"
                                [tooltipLarge]="true"
                            >
                            </agpr-text-input>
                        </div>

                        @if(dataConnectionService.hasEmailAccountProvision$ | async) {
                            <div class="agpr-emailComposerOvertake-field">
                                <div class="agpr-emailComposerOvertake-sendFrom">
                                    <div class="agpr-emailComposerOvertake-label">
                                        {{ "Discover.targeting.distribution.headerEditor.sendFrom" | localize }}
                                    </div>
                                    <agpr-dropdown
                                        [id]="'emailComposerOvertake_sendFromDropdown'"
                                        [options]="emailAccountOptions"
                                        [(ngModel)]="selectedDefaultEmailAccount"
                                        [callToAction]="sendFromCallToAction"
                                        [itemTemplate]="itemTemplate"
                                        panelStyleClass="agpr-emailComposerOvertake-sendFromItem-panel"
                                    >
                                        <ng-template let-item #itemTemplate>
                                            @if(item) {
                                                <div class="agpr-emailComposerOvertake-sendFromItem agpr-emailComposerOvertake-sendFromItem-panelPadding">
                                                    <span class="agpr-emailComposerOvertake-sendFromItem-label">{{item.label}}</span>
                                                    <span class="agpr-emailComposerOvertake-sendFromItem-spacer"></span>
                                                    <span class="agpr-emailComposerOvertake-sendFromItem-subLabel">{{item.subLabel}}</span>
                                                </div>
                                            }
                                        </ng-template>
                                    </agpr-dropdown>
                                </div>
                            </div>
                        }

                        <div class="agpr-emailComposerOvertake-fieldContainer">
                            <agpr-text-input #fromNameInput
                                placeholder="Discover.targeting.distribution.headerEditor.fromName.placeholder"
                                label="Discover.targeting.distribution.headerEditor.fromName"
                                tooltip="Discover.targeting.distribution.headerEditor.fromName.tooltip"
                                [required]="true"
                                [(ngModel)]="newEmailMessage.fromName"
                                [id]="'emailComposerOvertake_fromNameInput'"
                                [maxLength]="100"
                                [tooltipLarge]="true"
                            >
                            </agpr-text-input>

                            <agpr-text-input #replyEmailInput
                                placeholder="Discover.targeting.distribution.headerEditor.replyEmail.placeholder"
                                label="Discover.targeting.distribution.headerEditor.replyEmail"
                                tooltip="Discover.targeting.distribution.headerEditor.replyEmail.tooltip"
                                [required]="true"
                                [(ngModel)]="newEmailMessage.replyTo"
                                [id]="'emailComposerOvertake_replyEmailInput'"
                                [maxLength]="254"
                                [tooltipLarge]="true"
                            >
                            </agpr-text-input>
                        </div>
                        <agpr-rich-text-editor-ck
                            class="agpr-emailComposerOvertake-richTextEditor"
                            [richTextEditorConfig]="ckEditorConfig"
                            [(ngModel)]="newEmailMessage.bodyHtml"
                        ></agpr-rich-text-editor-ck>
                    }
                </div>
            </agpr-scroll-panel>
        </aside>

        <aside
            class="agpr-emailComposerOvertake-sidebar-right"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-rhp-contexts
                [id]="key + '_rhpContext'"
                [disableContentToggle]="true"
                [useWhiteBg]="true"
                [showFooter]="false"
            >
            </agpr-rhp-contexts>
        </aside>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
    </ng-template>
    @if (mode === emailComposerModes.COMPOSE) {
        <ng-template #takeOverFooterRight>
            <agpr-button
                [disabled]="!newEmailMessage.fromName || !newEmailMessage.replyTo ||!newEmailMessage.bodyHtml"
                label="Discover.emailComposer.actions.send"
                [style]="buttonTypes.primary"
                (click)="send()"
            ></agpr-button>
        </ng-template>
    }
</agpr-take-over-panel>
